import { render, staticRenderFns } from "./ScopesButton.vue?vue&type=template&id=20eb7539&"
import script from "./ScopesButton.vue?vue&type=script&lang=js&"
export * from "./ScopesButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports